<div data-testid="analysis-matrix">
  <app-coverage-tab-header
    titleKey="project.steps.rfi.invitationList.analysis.tab.matrix"
    subtitleKey="project.steps.rfi.invitationList.analysis.matrixLegend"
  >
    <app-coverage-option-toggle
      inputId="only-gap-countries"
      labelKey="project.steps.rfi.invitationList.analysis.onlyGapCountries"
      [(checked)]="onlyGapCountries"
    />
  </app-coverage-tab-header>

  <div class="ca-matrix">
    <table>
      <thead>
        <tr>
          <th>{{ 'project.steps.rfi.invitationList.analysis.matrixCorner' | transloco }}</th>
          @for (country of visibleCountries(); track country.isoCode) {
            <th [title]="country.name">
              {{ country.isoCode }}<br />
              <span class="text-muted-color text-sm">
                {{ country.employees | appNumber: '1.0-0' }}
                {{ 'project.steps.rfi.invitationList.analysis.employeesUnit' | transloco }}
              </span>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of visibleRows(); track row.functionName) {
          <tr>
            <td>
              <b>{{ row.functionName }}</b
              ><br />
              <span class="text-muted-color text-sm">
                {{ 'project.steps.rfi.invitationList.analysis.column.weight' | transloco }}
                {{ row.weightShare | appNumber: '1.2-2' }} %
              </span>
            </td>
            @for (cell of row.cells; track cell.isoCode) {
              <td>
                @switch (cell.status) {
                  @case ('covered') {
                    <span class="text-green">✓</span>
                  }
                  @case ('missing') {
                    <span class="text-red">✕</span>
                  }
                  @default {
                    <span class="text-muted-color">—</span>
                  }
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  <p class="text-muted-color text-sm mt-3">
    {{ 'project.steps.rfi.invitationList.analysis.matrixHint' | transloco: hintParams() }}
  </p>
</div>
